'use client'

import { useMedia } from '@/hooks'
import { MEDIA } from '@spot'
import { memo } from 'react'
import Button from '../Button/Button'

const GuuruButton = () => {
  const isDesktop = useMedia(MEDIA.desktop, true)

  if (!isDesktop) {
    return
  }

  const openChat = () => {
    if (typeof window.guuru !== 'undefined') {
      window.guuru.openChat()
    } else {
      console.error('Guuru ist noch nicht initialisiert')
    }
  }

  return (
    <Button
      id="open-guuru-chat"
      className="!text-neutral-100 [&_[data-line]]:!bg-neutral-100"
      onClick={openChat}
      variant="text"
      iconPosition="left"
      icon="material-symbols:chat-bubble-outline"
    >
      Chat
    </Button>
  )
}

export default memo(GuuruButton)
